import { CheckedAddress } from '@sparkdotfi/common-universal'

import { ProvidedBy } from '../../../common/types'
import { SavingsWithdrawTxOverview } from '../../types'
import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { TransactionOverview } from '@/ui/organisms/transaction-overview/TransactionOverview'
import { testIds } from '@/ui/utils/testIds'

interface SavingsWithdrawTransactionOverviewProps {
  txOverview: SavingsWithdrawTxOverview
}

function SavingsWithdrawTransactionOverview({ txOverview }: SavingsWithdrawTransactionOverviewProps) {
  if (txOverview.status !== 'success') {
    return <TransactionOverviewPlaceholder providedBy={txOverview.providedBy} savingsToken={txOverview.savingsToken} />
  }
  const {
    underlyingToken,
    underlyingTokenDepositedBefore,
    underlyingTokenDepositedAfter,
    tokenToReceive,
    tokenToReceiveAmount,
  } = txOverview

  const postFix =
    txOverview.mode.type === 'withdraw'
      ? 'Received'
      : txOverview.mode.receiver
        ? `Sent to ${CheckedAddress.formatShort(txOverview.mode.receiver)}`
        : 'Sent'

  return (
    <TransactionOverview providedBy={txOverview.providedBy}>
      {txOverview.savingsToken.symbol !== TokenSymbol('stUSDS') && (
        <TransactionOverview.Row>
          <TransactionOverview.Label>Savings Balance</TransactionOverview.Label>
          <TransactionOverview.SavingsBalanceChange
            token={underlyingToken}
            amountBefore={underlyingTokenDepositedBefore}
            amountAfter={underlyingTokenDepositedAfter}
          />
        </TransactionOverview.Row>
      )}
      <TransactionOverview.Row>
        <TransactionOverview.Label>Outcome</TransactionOverview.Label>
        <TransactionOverview.SavingsOutcome
          token={tokenToReceive}
          amount={tokenToReceiveAmount}
          postFix={postFix}
          dataTestId={testIds.dialog.savings.transactionOverview.outcome}
        />
      </TransactionOverview.Row>
    </TransactionOverview>
  )
}

function TransactionOverviewPlaceholder({ providedBy, savingsToken }: { providedBy: ProvidedBy; savingsToken: Token }) {
  const placeholder = '-'
  return (
    <TransactionOverview providedBy={providedBy}>
      {savingsToken.symbol !== TokenSymbol('stUSDS') && (
        <TransactionOverview.Row>
          <TransactionOverview.Label>Savings Balance</TransactionOverview.Label>
          <TransactionOverview.Generic>{placeholder}</TransactionOverview.Generic>
        </TransactionOverview.Row>
      )}
      <TransactionOverview.Row>
        <TransactionOverview.Label>Outcome</TransactionOverview.Label>
        <TransactionOverview.Generic>{placeholder}</TransactionOverview.Generic>
      </TransactionOverview.Row>
    </TransactionOverview>
  )
}

export {
  SavingsWithdrawTransactionOverview as TransactionOverview,
  type SavingsWithdrawTransactionOverviewProps as TransactionOverviewProps,
}
